import {Component, HostListener, OnInit} from '@angular/core';
import {ViewportScroller} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    // Navbar Sticky
    isSticky = false;
    classApplied = false;

    constructor(private viewportScroller: ViewportScroller,
                private route: ActivatedRoute,
                private router: Router) {
    }

    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (scrollPosition >= 50) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }

    public onClick(elementId: string): void {
        if (this.router.url.includes('home')) {
            this.viewportScroller.scrollToAnchor(elementId);
        } else {
            if (elementId === 'home') {
                this.router.navigate(['/home']).then();
            } else if (elementId !== 'charts') {
                this.router.navigate(['/home'], {fragment: elementId}).then();
            }
        }
    }

    ngOnInit() {}

    toggleClass() {
        this.classApplied = !this.classApplied;
    }

}
